import Weather from './weather';
export default Weather;
